import Iconify from "../../components/Iconify";

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    id: "dashboard.view",
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon("carbon:dashboard"),
  },
  {
    id: "search_uid.view",
    title: "Search By UID",
    path: "/search-user",
    icon: getIcon("mingcute:user-search-fill"),
  },

  {
    title: "Users",
    path: "/delete",
    icon: getIcon("fa7-solid:home-user"),
    children: [
      {
        id: "users.view",
        title: "All Users",
        path: "/users",
        icon: getIcon("fa:users"),
      },
      {
        id: "users.update",
        title: "Change User",
        path: "/change-users",
        icon: getIcon("ri:user-add-line"),
      },
      {
        id: "active_users.view",
        title: "Active",
        path: "/active-users",
        icon: getIcon("ooui:user-active"),
      },
      {
        id: "inactive_users.view",
        title: "Inactive",
        path: "/inactive-users",
        icon: getIcon("tabler:user-off"),
      },
      {
        id: "blocked_users.view",
        title: "Blocked",
        path: "/blocked-users",
        icon: getIcon("tabler:user-cancel"),
      },
      {
        id: "temprary_delete_users.view",
        title: "Temprary Delete",
        path: "/delete/temprary",
        icon: getIcon("material-symbols:replay-30"),
      },
      {
        id: "permanent_delete_users.view",
        title: "Permanent Delete",
        path: "/delete/permanent",
        icon: getIcon("streamline-freehand:delete-bin-5"),
      },
    ],
  },
  {
    id: "open_level.view",
    title: "Open Level",
    path: "/open-level",
    icon: getIcon("carbon:increase-level"),
  },
  {
    id: "transfer.view",
    title: "Transfer Amount",
    path: "/transfer-amount",
    icon: getIcon("mdi:transfer"),
  },

  {
    id: "admin_management.view",
    title: "Admin Management",
    icon: getIcon("hugeicons:list-setting"),
    children: [
      {
        id: "roles.view",
        title: "Roles",
        path: "/role",
        icon: getIcon("oui:app-users-roles"),
      },
      {
        id: "assign_permissions.view",
        title: "Assign Permissions",
        path: "/assign-permission",
        icon: getIcon("icon-park-outline:permissions"),
      },
      {
        id: "sub_admins.view",
        title: "Sub Admins",
        path: "/sub-admin",
        icon: getIcon("grommet-icons:user-admin"),
      },
    ],
  },
  {
    title: "Blog Section",
    icon: getIcon("carbon:blog"),
    children: [
      {
        id: "categories.view",
        title: "Categories",
        path: "/blog-categories",
        icon: getIcon("iconamoon:category"),
      },
      {
        id: "blogs.view",
        title: "Blogs",
        path: "/blogs-list",
        icon: getIcon("icomoon-free:blog"),
      },
    ],
  },
  {
    title: "Wallet Section",
    icon: getIcon("akar-icons:wallet"),
    children: [
      {
        id: "wallet_estimate.view",
        title: "Wallet Estimate",
        path: "/wallet-estimate",
        icon: getIcon("ri:user-add-line"),
      },
      {
        id: "wallet_stats.view",
        title: "Wallet Stats",
        path: "/wallet-stats",
        icon: getIcon("nimbus:stats"),
      },
      {
        id: "wallet_execute.view",
        title: "Wallet Execute",
        path: "/wallet-execute",
        icon: getIcon("ri:user-add-line"),
      },
      {
        id: "wallet.view",
        title: "Wallet List",
        path: "/wallet-list",
        icon: getIcon("line-md:list"),
      },
      {
        id: "wallet_history.view",
        title: "Wallet History",
        path: "/wallet-history",
        icon: getIcon("bx:history"),
      },
    ],
  },
  {
    id: "ledgers.view",
    title: "Broker Ledger",
    path: "/broker-ledger",
    icon: getIcon("emojione-monotone:ledger"),
  },
  //  {
  //   id: "ledgers.view",
  //   title: "Categories Section",
  //   path: "/blog-categories",
  //   icon: getIcon("mingcute:user-search-fill"),
  // },

  {
    title: "Logs Section",
    icon: getIcon("hugeicons:list-setting"),
    children: [
      {
        id: "activity_logs.view",
        title: "Active Log",
        path: "/active-log",
        icon: getIcon("tabler:logs"),
      },
      {
        id: "admin_logs.view",
        title: "Admin Active Log",
        path: "/admin-active-log",
        icon: getIcon("streamline-logos:elastic-logstash-logo-solid"),
      },
      {
        id: "system_logs.view",
        title: "System Active Log",
        path: "/system-active-log",
        icon: getIcon("hugeicons:list-setting"),
      },
      {
        id: "future_logs.view",
        title: "Fututre System Logs",
        path: "/future-system-log",
        icon: getIcon("hugeicons:list-setting"),
      },
    ],
  },
  {
    id: "deposit.view",
    title: "Deposit",
    icon: getIcon("hugeicons:atm-01"),
    children: [
      {
        id: "spot_deposit.view",
        title: "Spot Deposit",
        path: "/deposit-list",
        icon: getIcon("mingcute:wallet-line"),
      },
      {
        id: "arbitrage_deposit.view",
        title: "Arbitrage Deposit",
        path: "/exbotix-history",
        icon: getIcon("icon-park-outline:deposit"),
      },
    ],
  },

  {
    id: "kycs.view",
    title: "KYC Managements",
    icon: getIcon("solar:user-id-outline"),
    children: [
      {
        id: "inprocess_kyc.view",
        title: "In Process KYC Management",
        path: `/kyc-list/${"in_process"}`,
        icon: getIcon("uit:process"),
      },
      {
        id: "kycs.approve",
        title: "Verified KYC Management",
        path: `/kyc-list/${"verified"}`,
        icon: getIcon("solar:diploma-verified-outline"),
      },
      {
        id: "kycs.reject",
        title: "Rejected KYC Management",
        path: `/kyc-list/${"rejected"}`,
        icon: getIcon("pepicons-pencil:identification-off"),
      },
      {
        id: "kycs.update",
        title: "KYC Country Update",
        path: `/kyc-country-update`,
        icon: getIcon("qlementine-icons:update-24"),
      },
    ],
  },
  {
    id: "arbitrage.view",
    title: "Arbitrage",
    icon: getIcon("solar:user-id-outline"),
    children: [
      {
        id: "arbitrage_release.view",
        title: "Arbitrage Release All",
        path: `/release-all`,
        icon: getIcon("flowbite:share-all-solid"),
      },
      {
        id: "arbitrage_unrealize.view",
        title: "Arbitrage Unrealize Apply",
        path: `/unrealize-apply`,
        icon: getIcon("pepicons-pencil:identification-off"),
      },
      {
        id: "arbitrage_unrealize_release.view",
        title: "Arbitrage Unrealize Release",
        path: `/unrealize-release`,
        icon: getIcon("pepicons-pencil:identification-off"),
      },
      {
        id: "arbitrage_hold.view",
        title: "Arbitrage Hold",
        path: "/arbitrage-hold",
        icon: getIcon("fa7-solid:hand-holding-usd"),
      },
    ],
  },
  {
    id: "permission.view",
    title: "Ip Permission",
    path: "/ip-permission",
    icon: getIcon("icon-park-twotone:permissions"),
  },

  {
    id: "bypass_user_withdraw.view",
    title: "Bypass User Withdraw",
    path: "/update-user-list",
    icon: getIcon("fa7-solid:hand-holding-usd"),
  },
  {
    id: "user_earn.view",
    title: "User Earn Plan",
    path: "/user-earn",
    icon: getIcon("stash:plan"),
  },
  {
    id: "bypass_user.view",
    title: "BuyPass User",
    path: "/bypass-user",
    icon: getIcon("fa6-solid:person-through-window"),
  },
  {
    id: "transaction.view",
    title: "Transaction",
    path: "/transaction-list",
    icon: getIcon("tabler:transaction-dollar"),
  },
  {
    id: "ai.view",
    title: "AI Section",
    icon: getIcon("hugeicons:ai-brain-03"),
    children: [
      {
        id: "ai_signal.view",
        title: "AI Signal",
        path: "/ai-signal",
        icon: getIcon("lets-icons:candlestick"),
      },
      {
        id: "signal_stats.view",
        title: "AI Signal Stats",
        path: "/ai-signal-stats",
        icon: getIcon("ion:stats-chart"),
      },
      {
        id: "ai_subscriptions.view",
        title: "AI Subscriptions",
        path: "/ai-subscriptions",
        icon: getIcon("streamline:subscription-cashflow-remix"),
      },
    ],
  },
  {
    id: "subscription.view",
    title: "Subscriptions Section",
    icon: getIcon("reicon:subscription"),
    children: [
      {
        id: "subscriptions.create",
        title: "Add Subscription",
        path: "/add-subscription",
        icon: getIcon("ant-design:appstore-add-outlined"),
      },
      {
        id: "subscription_plans.view",
        title: "Subscription Plans",
        path: "/package-list",
        icon: getIcon("hugeicons:package-receive"),
      },

      {
        id: "user_subscriptions.view",
        title: "User Subscriptions",
        path: "/user-subscription",
        icon: getIcon("stash:subscription-list"),
      },
    ],
  },

  {
    id: "withdraw.view",
    title: "withdrawal Active",
    path: "/withdraw-active",
    icon: getIcon("solar:card-send-linear"),
  },
  {
    id: "withdraw.view",
    title: "withdrawals",
    path: "/withdraw-list",
    icon: getIcon("solar:card-send-linear"),
  },
  {
    id: "system_setting.view",
    title: "System Settings",
    path: "/system-setting",
    icon: getIcon("grommet-icons:system"),
  },
  {
    id: "spot.view",
    title: "Spot Wallet",
    path: "/spot-wallet",
    icon: getIcon("et:wallet"),
  },
  {
    id: "daily_report.view",
    title: "Daily Report",
    path: "/daily-report",
    icon: getIcon("hugeicons:task-daily-01"),
  },
  {
    id: "daily_pnl.view",
    title: "Daily Pnl",
    path: "/daily-pnl",
    icon: getIcon("game-icons:profit"),
  },
  {
    id: "top_traders.view",
    title: "Top Traders",
    path: "/top-traders",
    icon: getIcon("streamline-ultimate:trading-pattern-up"),
  },
  {
    id: "top_volume.view",
    title: "Top Volume",
    path: "/top-volume",
    icon: getIcon("akar-icons:align-top"),
  },
  {
    id: "arbitrage_balance.view",
    title: "Arbitrage Balance",
    path: "/balance",
    icon: getIcon("game-icons:money-stack"),
  },

  {
    id: "banners.view",
    title: "Banners",
    path: "/banner-list",
    icon: getIcon("game-icons:vertical-banner"),
  },

  {
    id: "earn_plan_stats.view",
    title: "Earn Plan Stats",
    path: "/earn-plan-stats",
    icon: getIcon("nimbus:stats"),
  },

  {
    id: "api_keys.view",
    title: "Api Key",
    path: "/api-key",
    icon: getIcon("flowbite:api-key-outline"),
  },
  {
    id: "customer_response.view",
    title: "Customer Response",
    path: "/customer-support",
    icon: getIcon("streamline-plump:customer-support-7-solid"),
  },
  {
    id: "events.view",
    title: "Event List",
    path: "/event-list",
    icon: getIcon("bi:calendar2-event"),
  },
];

export default navConfig;
